import React from "react";

import { Typography } from "../../ppui";
import { Button } from "../../ppui/button";

import {
  PaginationLeft,
  PaginationRight,
  TablePagination,
} from "./table-style";

const PaginationControls = ({
  rowsPerPage,
  handleRowsPerPageChange,
  currentPage,
  totalPages,
  handlePreviousPage,
  handleNextPage,
}) => {
  return (
    <>
      <TablePagination>
        <PaginationLeft>
          <Typography variant="body2" mb="0">
            Rows per page:
          </Typography>
          <select
            id="rowsPerPage"
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
          >
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={200}>200</option>
          </select>
        </PaginationLeft>

        <PaginationRight>
          <Button
            size="sm"
            variant="outlined"
            onClick={handlePreviousPage}
            disabled={currentPage === 0}
          >
            Previous
          </Button>
          <Typography variant="body2" mb="0">
            
            Page {totalPages ?currentPage + 1:0} of {totalPages}
          </Typography>
          <Button
            size="sm"
            variant="outlined"
            onClick={handleNextPage}
            disabled={currentPage + 1 === totalPages}
          >
            Next
          </Button>
        </PaginationRight>
      </TablePagination>
    </>
  );
};

export default PaginationControls;
